var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"welcomeGroup":"Educators and Staff","routePath":"myeducationdiscount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }